import { useState } from "react";
// this hook will be utilize when react-hook-form is not utilized
const useErrorMessage = () => {
  const [error, setError] = useState({ show: false, message: "" });

  const showError = (message = "") => {
    setError({ show: true, message });
  };

  const hideError = () => {
    setError({ show: false, message: "" });
  };

  return {
    error,
    showError,
    hideError,
  };
};

export default useErrorMessage;
